// Just a reference for now.
// eslint-disable-next-line no-restricted-globals
export const warn = self.console.warn;
